import { ContactInterceptorService } from "@amazon-connect/contact-ui";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/**
 * Interceptors can block or alter agent actions. Off by default and always pass-through.
 * Registered here so the surface is visible, never auto-enabled.
 *
 * `registerContactInterceptor` is a private prototype method (amendment A11) and is
 * intentionally excluded from the public request list and added to the conformance IGNORED set.
 *
 * `ContactInterceptorService` takes the provider directly, not `{ provider }` (amendment A7) —
 * passing a config object here yields a dead manager that can never register an interceptor.
 */
export const contactUiModule: ClientModule = {
  id: "contact-ui",
  label: "Contact UI (interceptors)",
  pkg: "@amazon-connect/contact-ui",
  clientExport: "ContactInterceptorService",
  kind: "interceptor",
  create: (provider: AmazonConnectProvider) =>
    new ContactInterceptorService(provider) as unknown as Record<
      string,
      unknown
    >,
  events: [],
  requests: [
    { name: "addOpenQuickConnectInterceptor", args: [], mutating: true },
    { name: "removeOpenQuickConnectInterceptor", args: [], mutating: true },
    { name: "addOpenOutboundDialerInterceptor", args: [], mutating: true },
    { name: "removeOpenOutboundDialerInterceptor", args: [], mutating: true },
    { name: "addClearContactInterceptor", args: [], mutating: true },
    { name: "removeClearContactInterceptor", args: [], mutating: true },
  ],
};
